module.exports = __webpack_public_path__ + "img/ferry2_JP.da52bb9d.jpg";